import { render, staticRenderFns } from "./SomePage1.vue?vue&type=template&id=54725af2&scoped=true&"
import script from "./SomePage1.vue?vue&type=script&lang=js&"
export * from "./SomePage1.vue?vue&type=script&lang=js&"
import style0 from "./SomePage1.vue?vue&type=style&index=0&id=54725af2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54725af2",
  null
  
)

export default component.exports